type ApiError = {
  response?: {
    status?: number;
    data?: { error_type?: string; error?: string; message?: string; validation_error?: string };
    error?: string;
    messages?: string[];
    redirect?: string;
  };
  code?: string;
  message?: string;
  name?: string;
  statusCode?: number;
  graphQLErrors?: Array<{ message: string; extensions?: { code?: string | number } }>;
};

export function isApiError(error: unknown): error is ApiError {
  return typeof error === "object" && error !== null && "response" in error;
}

export function hasGraphQLErrors(error: unknown): error is {
  graphQLErrors: Array<{ message: string; extensions?: { code?: string | number } }>;
  message?: string;
  name?: string;
} {
  return (
    typeof error === "object" &&
    error !== null &&
    "graphQLErrors" in error &&
    Array.isArray((error as { graphQLErrors: unknown }).graphQLErrors)
  );
}

export function hasStatusCode(error: unknown): error is { statusCode: number } {
  return (
    typeof error === "object" &&
    error !== null &&
    "statusCode" in error &&
    typeof (error as { statusCode: unknown }).statusCode === "number"
  );
}
